<ng-container *transloco="let t">
  <app-page-template>
    <div class="container">
      <div class="pt-48-38 pb-300-228">
        @if (signupComponentState === SignupComponentState.SUCCESS) {
        <section class="upper-section py-5 px-4">
          <div class="upper-section-background image-fade-in" [@fadeInAnimation]="'in'"></div>
          <div class="d-block d-md-flex justify-content-center align-items-center">
            <div>
              <app-form-card>
                <ng-container>
                  <app-alert-success />
                  <h4 class="text-center">{{ t('signup.result.success.info.verify.1') + " " +
                    (((inputForm.controls.email.value?.length ?? 0) > 0) ? inputForm.controls.email.value :
                    t('signup.result.success.info.verify.3')) }}</h4>
                  <p class="text-center pt-3">{{ t('signup.result.success.info.verify.2') }}</p>
                  <div class="text-center separator mt-2">
                    <span class="fs-13-px">{{ t('signup.result.success.info.retry') }}</span>
                    <span class="link-button ps-1 fw-bold fs-13-px" (click)="setInitialState()">{{
                      t('signup.result.success.info.retry.button') }}</span>
                  </div>
                  <div class="separator my-5"></div>
                  <app-button [label]="t('signup.verification.go.to.login')" [btnClass]="'btn-primary-red btn-large'"
                    (onClick)="toLogin()" />
                </ng-container>
              </app-form-card>
            </div>
          </div>
        </section>
        } @else {
        <app-grey-card-with-title [title]="t('signup.create.your.free.account')" [removeContentPaddingTop]="true">
          <div class="text-center pb-20 pt-20">
            <span>{{ t('signup.already.have.an.account') }}</span>
            <span class="link-button ps-2 fw-bold" (click)="toLogin()">{{ t('app.common.login') }}</span>
          </div>
          <div class="px-10">
            <form #signUp="ngForm" [formGroup]="inputForm">
              <app-input formControlName="email" label="app.common.email" />
              <div class="pt-20-10">
                <app-input type="password" formControlName="password" label="app.common.password"
                  [hideErrorMessage]="true" />
                @if (inputForm.controls.password.touched && inputForm.controls.password.errors) {
                @if (inputForm.controls.password.errors['required']) {
                <div class="errorMes pt-1">
                  {{ t('app.common.error.required') }}
                </div>
                } @else {
                <div class="errorMes pt-1">
                  {{ t("app.common.error.password.prefix") }}:
                </div>
                @for(errorMessage of inputForm.controls.password.errors | errorMessages:'password':true; track
                errorMessage){
                <div class="errorMes pt-1">
                  <div class="ps-3 d-inline-flex">
                    <i class="bi bi-dot"></i>
                    {{ errorMessage }}
                  </div>
                </div>
                }
                }
                }
              </div>
              <div class="pt-20-10">
                <app-input formControlName="firstName" label="app.common.first.name" />
              </div>
              <div class="pt-20-10">
                <app-input formControlName="lastName" label="app.common.last.name" />
              </div>
              <div class="pt-20-10">
                <app-select formControlName="gender" [items]="genders" labelKeyPrefix="app.common.gender."
                  label="app.common.gender" labelKey="id" valueKey="id" />
              </div>
              @if(signupComponentState === SignupComponentState.ERROR){
              <div class="pt-4">
                <span class="error-message">{{ t('signup.error.email.taken') }}</span>
              </div>
              }
              <div class="pt-20-10 mt-30 d-flex justify-content-center pb-16">
                <app-rounded-button [label]="t('app.common.signup')" (onClick)="onRegister()" />
              </div>
              <div class="fs-14 text-center pt-16">
                {{ t("signup.terms.of.service.pt.1") }} <span class="text-decoration-underline cursor-pointer">{{
                  t("signup.terms.of.service.pt.2") }}</span>. {{
                t("signup.terms.of.service.pt.3")
                }}
                <span class="text-decoration-underline cursor-pointer">{{ t("signup.terms.of.service.pt.4") }}</span>.
              </div>
              <app-section-divider />
              @if(currentWindowWidth >= 768){
                <div class="d-flex justify-content-center">
                  <div class="social-wrapper">
                    <div class="text-center">
                      <asl-google-signin-button type='standard' size='large' shape="pill" theme="filled_blue"
                        [width]="googleSigninButton" [text]="t('signup.continue.with.google')"/>
                    </div>
                    <div class="pt-3 text-center">
                      <app-button [label]="t('signup.continue.with.facebook')" (onClick)="onFacebookLogin()"
                        [btnClass]="'btn-facebook btn-large social-network-button'">
                        <img src="assets/img/facebook-circle-icon-white.png" alt="" width="36" height="36">
                      </app-button>
                    </div>
                  </div>
                </div>
              }@else {
                <div class="d-flex align-items-center justify-content-center">
                  <div class="pe-3">
                    <asl-google-signin-button type='icon' size='large' shape="pill" theme="filled_blue"
                      [text]="t('signup.continue.with.google')"/>
                  </div>
                  <div class="link" (click)="onFacebookLogin()">
                    <img src="assets/img/facebook_circle_icon.svg" alt="" width="44" height="44">
                  </div>
                </div>
              }
            </form>
          </div>
        </app-grey-card-with-title>
        }
      </div>
    </div>
    <app-footer />
  </app-page-template>
</ng-container>
